import React from 'react'

const Settings: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center px-12 lg:px-16 lg:py-24 py-16 bg-white rounded-2xl shadow-sm border border-gray-100 w-11/12 max-w-3xl lg:max-w-4xl">
        <div className="mx-auto h-24 w-24 rounded-full bg-orange-100 flex items-center justify-center mb-6">
          <span className="text-5xl">🚧</span>
        </div>
        <h1 className="text-3xl lg:text-4xl font-semibold text-gray-900 mb-3">
          Page Under Construction
        </h1>
        <p className="text-gray-600 mb-8 text-base lg:text-lg max-w-2xl mx-auto">
          We&apos;re working hard to bring this page to you soon. Please check
          back later.
        </p>
        <div className="inline-flex items-center gap-3 text-sm lg:text-base text-gray-500">
          <span>Need help?</span>
          <a href="/" className="text-orange-600 hover:underline">
            Go to Dashboard
          </a>
        </div>
      </div>
    </div>
  )
}

export default Settings
